/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from './http-client'

export class ApiIbanValidationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-iban-validation-controller
   * @name GetBicForIban
   * @request GET:/api/v1/iban/{iban}/bic
   */
  getBicForIban = (iban: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/iban/${iban}/bic`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getBicForIbanPath = '/v1/iban/${iban}/bic'
  static getBicForIbanMethod = 'GET'
}
